import React from 'react';
import {goToUrl} from '@/common-pages/game-navigate';
import {Swiper} from 'antd-mobile';
import {TouchableOpacity, Image} from '@/components-v2';
import {BannerListItem} from '@/pages/home/home.type';

const HomeBanner = ({bannerList}: {bannerList: BannerListItem[]}) => {
  return (
    <div className="relative bg-gradient-to-b from-[#F9B871] to-[#F11402] rounded-b-[40%] h-[8.25rem]">
      <Swiper className="mt-3 h-[7.5rem]" autoplay loop>
        {bannerList.map(item => {
          return (
            <Swiper.Item
              key={item.bannerId}
              className="px-3"
              onClick={() => goToUrl(item.skipLinks, item.title)}>
              <TouchableOpacity>
                <Image src={item.bannerImg} className="rounded-lg w-full" />
              </TouchableOpacity>
            </Swiper.Item>
          );
        })}
      </Swiper>
    </div>
  );
};

export default HomeBanner;
